"use client";
import { cn } from "@/lib/utils";
import { COLOR_PICKER } from "@/types/Contentful.model";
import Link from "next/link";
import React from "react";
import { MdOpenInNew } from "react-icons/md";
import { Typography } from "../Typography/Typography.component";
import { IntroModulePropsModel } from "./IntroModule.model";

const IntroModule = ({
  title,
  description,
  client,
  year,
  capabilities,
  recognition,
  clientWebsiteUrl,
  backgroundColor,
}: IntroModulePropsModel) => {
  const cssClass =
    backgroundColor.name === "Black" ? "text-core-white" : "text-core-black";

  const generateTableData = () => {
    const dataNodes: React.JSX.Element[] = [];
    for (const [key, value] of Object.entries({
      client,
      year,
      capabilities,
      recognition,
    })) {
      if (value) {
        dataNodes.push(
          <Typography.LABEL1 key={key}>
            {key.toLocaleUpperCase()}
          </Typography.LABEL1>,
        );
        dataNodes.push(
          <Typography.LABEL2 key={value}>{value}</Typography.LABEL2>,
        );
      }
    }

    if (clientWebsiteUrl) {
      dataNodes.push(
        <div className="col-start-2 grid grid-cols-subgrid" key="website-url">
          <Link
            href={clientWebsiteUrl}
            target="_blank"
            className="gap-xxs flex items-center no-underline"
          >
            <Typography.LABEL2>Launch Website</Typography.LABEL2>
            <MdOpenInNew size={20} className={cn(cssClass)} />
          </Link>
        </div>,
      );
    }
    return dataNodes;
  };

  return (
    <div
      className={cn(
        `bg-${COLOR_PICKER[backgroundColor.name as keyof typeof COLOR_PICKER]}`,
        "px-sm md:px-md lg:px-lg py-20",
      )}
    >
      <div className="col-span-12 grid">
        <div className={cn(cssClass, "grid grid-cols-1 md:grid-cols-2")}>
          <div className="gap-y-xl grid place-self-start md:max-w-[27rem]">
            <Typography.H4>{title}</Typography.H4>
            <Typography.BODY2>{description}</Typography.BODY2>
          </div>
          <div className="mt-40 grid">
            <div className="gap-y-md md:gap-x-xxxxl grid w-full grid-cols-2 gap-x-0 place-self-end md:w-auto md:grid-cols-[min-content_1fr]">
              {generateTableData()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroModule;
